import FileComponents from './File.vue';

const file = {
    install:function(Vue) {
        Vue.component('file', FileComponents)
    }
}

export default file;